import React, { useEffect, useRef, useState } from "react";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import arrows from '../../../src/assets/images/mo_icon/mo_arrow_left.svg'

const PromotionMoDesign = (props) => {
    const Navigate = useNavigate()
    const location = useLocation();
    const { id, activeState } = location.state || {};
    const [banners, setBanners] = useState([]);
    const [currentActive, setCurrentActive] = useState(activeState || id || null);
    const activeRef = useRef(null);
    const [htmlData, setHtmlData] = useState('');


    useEffect(() => {
        const currentDate = new Date().toISOString().split("T")[0];

        makeAjax(url.PLAYER_API.getPromoBanner, { date: currentDate }, url.PLAYER_MS_EXT).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            setBanners(response.data);
        });
    }, []);

    useEffect(() => {
        if (banners.length > 0 && currentActive) {
            setTimeout(() => {
                if (activeRef.current) {
                    activeRef.current.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }, 100);
        }
    }, [banners, currentActive, htmlData]);


    const handleMoreInfoClick = (id) => {
        setCurrentActive((prevActive) => (prevActive === id ? null : id));
    };


    useEffect(() => {
        // Inject CSS for list styles
        const style = document.createElement('style');
        style.innerHTML = `
            /* Styling for unordered list (ul) items */
             ul {
                list-style-type: disc !important;
                padding-left: 20px;
                }
            li {
                color: #FFFFFF !important; /* Set the text color to white */
            }
    
            /* Styling for paragraph tags */
            p {
                color: #FFFFFF !important;
            }
    
            /* Styling for span tags */
            span {
                color: #FFFFFF !important;
            }
    
            /* Ensure the bullet points of ul lists are white */
            ul li::marker {
                color: #FFFFFF !important;
            }
    
            /* Styling for ordered lists (numbered lists) */
            ol {
                list-style-type: decimal !important; /* Use decimal numbering (1, 2, 3...) */
                padding-left: 20px !important; /* Add some indentation */
            }
    
            ol li {
                color: #FFFFFF !important; /* Ensure ordered list items are white */
            }
        `;
        document.head.appendChild(style);

        const currentDate = new Date().toISOString().split("T")[0];

        makeAjax(
            url.PLAYER_API.getPromoBanner,
            { date: currentDate },
            url.PLAYER_MS_EXT
        ).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            setBanners(response.data);

            // Store HTML data for each banner individually
            const newHtmlData = {};
            response.data.forEach((banner) => {
                newHtmlData[banner.id] = banner.body || ""; // Assuming 'body' holds the HTML content
            });
            setHtmlData(newHtmlData);

        });

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <div className='mo_coinreward promotion-mo-page'>
            <div className='mo_pages_topbar'>
                <div className='back_arrow' onClick={() => Navigate("/")}>
                    <img src={arrows}></img>
                </div>
                <div className="mo_page_heading">
                    <h2>Promotion</h2>
                </div>
            </div>
            <div className="promotion-wrapper">
                <div className="promotions-container">
                    {banners.map((banner) => (
                        // (banner.redirect_link === "promotion" || banner.redirect_link === "promotion_only") && (
                        (banner.flag_promotionmenu === 1) && (
                            <div
                                key={banner.id}
                                className={`promotion ${currentActive === banner.id ? "active" : ""}`}
                                id={`promo-${banner.id}`}
                                ref={currentActive === banner.id ? activeRef : null}
                            >
                                <div className="promotion-banner-holder">
                                    <img
                                        src={banner.updated_mobile_banner}
                                        alt="Mobile Banner"
                                        className="mobile_portrait_banner_img"
                                        name={banner.redirect_link}
                                        onClick={() => handleMoreInfoClick(banner.id)}
                                    />
                                </div>
                                <div
                                    className={`promo-content-outer ${currentActive === banner.id ? "highlight" : ""
                                        }`}
                                    style={{
                                        //maxHeight: currentActive === banner.id ? 1000 : 0,
                                        //transition: "max-height 0.3s ease, background-color 0.3s ease",
                                        height: currentActive === banner.id ? "100%" : 0,
                                        transition: "height 0.3s ease, background-color 0.3s ease",
                                    }}
                                >
                                    <div className="promo-content">
                                        <div className="promotion_content_header">
                                            <h4>Start date : {banner.date_start}</h4>
                                            <h4>END date : {banner.date_end}</h4>
                                        </div>
                                        <div className="promotion-cnt">

                                            <h2 className="promotion-heading">{banner.title}</h2>
                                            {/* {banner.body.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "").trim()} */}
                                            <div dangerouslySetInnerHTML={{ __html: htmlData[banner.id] || '' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </div>

        </div>
    );
};

export default PromotionMoDesign;
